// MARK://dhk8/pos/lib/queries/invoices
// Queries tipadas de facturas — F4.5 / ADR-0009. El POS lee facturas por el grafo
// (erp-invoices, tenant del JWT) — mismas queries que Admin (invoices/invoice). El
// cliente fiscal se resuelve por federación (Invoice.customer → erp-customers). Las
// escrituras (crear/timbrar/cancelar/global) siguen REST. Campos inline.
import { graphql } from '../../gql/index.js'

export const PosInvoicesQuery = graphql(`
  query PosInvoices($limit: Int, $status: String, $customerId: String) {
    invoices(limit: $limit, status: $status, customerId: $customerId) {
      items {
        id tenantId customerId folio status totalCents paidCents currency
        issuedAt paidAt cfdiUuid satMotivo notes posOrderId createdAt
        customer { id legalName rfc }
      }
      total
    }
  }
`);

export const PosInvoiceQuery = graphql(`
  query PosInvoice($id: ID!) {
    invoice(id: $id) {
      id tenantId customerId folio status totalCents paidCents currency
      issuedAt paidAt cfdiUuid satMotivo notes posOrderId createdAt
      customer { id legalName rfc }
      lines { id description qty unitCents totalCents taxRate productId }
    }
  }
`);


export const PosCancelInvoiceMutation = graphql(`
  mutation PosCancelInvoice($id: ID!, $input: ErpCancelInvoiceInput!) {
    cancelInvoice(id: $id, input: $input) {
      id tenantId customerId folio status totalCents paidCents currency
      issuedAt paidAt cfdiUuid satMotivo notes posOrderId createdAt
      customer { id legalName rfc }
      lines { id description qty unitCents totalCents taxRate productId }
    }
  }
`);
